document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('[data-menu-toggle]');
  if (menuButton) {
    const nav = document.querySelector('[data-mobile-nav]');
    const open = nav.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(open));
  }

  const submenuButton = event.target.closest('[data-submenu-toggle]');
  if (submenuButton) {
    const item = submenuButton.closest('.nav-item');
    const open = item.classList.toggle('submenu-open');
    submenuButton.setAttribute('aria-expanded', String(open));
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button');
  const original = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding…';
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }] })
    });
    if (!response.ok) throw new Error('Unable to add');
    const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((r) => r.json());
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    button.textContent = 'Added ✓';
  } catch (_) { button.textContent = 'Try again'; }
  setTimeout(() => { button.disabled = false; button.textContent = original; }, 1600);
});

document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-tab-target]');
  if (!tab) return;
  const section = tab.closest('[data-collection-tabs]');
  section.querySelectorAll('[data-tab-target]').forEach((button) => {
    const selected = button === tab;
    button.classList.toggle('active', selected);
    button.setAttribute('aria-selected', String(selected));
  });
  section.querySelectorAll('.collection-panel').forEach((panel) => {
    const selected = panel.id === tab.dataset.tabTarget;
    panel.classList.toggle('active', selected);
    panel.hidden = !selected;
  });
});
